import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { useWhatWeDoCommon } from "@/pages-react/what-we-do/WhatWeDoCommon.tsx";
import { LayoutStyleTypes } from "@/util-react/layout";

export const WhatWeDoMobile = withCatalogLayout((props: { content: string }) => {
  const { renderContent } = useWhatWeDoCommon(props.content);

  return <>{renderContent()}</>;
}, LayoutStyleTypes.TYPE_SM);
